/* eslint-disable prettier/prettier */
import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Text,
} from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { IData } from '../../types/shared';
import { IApuracao, useApuracoes } from '../../hooks/useApuracoes';

function formatDateOnly(dateString: string): string {
  if (!dateString) return '';
  const [year, month, day] = dateString.split('-');
  return `${day}/${month}/${year}`;
}
function formatDateBrazil(dateString: string, withTime = false): string {
  if (!dateString) return '';
  const date = new Date(dateString);

  const options: Intl.DateTimeFormatOptions = withTime
    ? {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      }
    : {
        timeZone: 'America/Sao_Paulo',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      };

  return new Intl.DateTimeFormat('pt-BR', options).format(date);
}

interface ViewApuracaoModalProps {
  id: string | number; // empresa id
  dateStart?: string;
  dateEnd?: string;
  children?: React.ReactElement;
}

const ViewApuracaoModal = ({ id, dateStart, dateEnd, children }: ViewApuracaoModalProps) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { getApuracoes } = useApuracoes();

  const { data, isFetching } = useQuery<IData<IApuracao[]>>({
    queryKey: [
      'ApuracoesList',
      { empresa_id: id, date_start: dateStart, date_end: dateEnd, page: 1, size: 50 },
    ],
    queryFn: getApuracoes,
    enabled: isOpen,
  });

  return (
    <>
      {children ? (
        React.cloneElement(children, { onClick: onOpen })
      ) : (
        <Button onClick={onOpen}>Ver Apurações</Button>
      )}

      <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Apurações</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {isFetching && <Text>Carregando apurações...</Text>}
            {!isFetching && (!data?.data?.items || data.data.items.length === 0) && (
              <Text>Nenhuma apuração encontrada.</Text>
            )}
            {!isFetching && data?.data?.items && data.data.items.length > 0 && (
              <table className="w-full table-auto border-collapse border border-gray-300">
                <thead>
                  <tr>
                    <th className="border border-gray-300 p-2">Data e Hora Apuração</th>
                    <th className="border border-gray-300 p-2">Competência</th>
                    <th className="border border-gray-300 p-2">Usuário</th>
                  </tr>
                </thead>
                <tbody>
                  {data.data.items.map(apuracao => (
                    <tr key={apuracao.id}>
                      <td className="border border-gray-300 p-2">
                        {formatDateBrazil(apuracao.dt_apuracao, true)} {/* false = só data */}
                      </td>
                      <td className="border border-gray-300 p-2">
                        {formatDateOnly(apuracao.dt_competencia)}
                      </td>
                      <td className="border border-gray-300 p-2">{apuracao.usuario}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </ModalBody>

          <ModalFooter>
            <Button onClick={onClose}>Fechar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ViewApuracaoModal;
